import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticateGuard } from '@app/core/authentication/authenticate.guard';
import { MyZoneRoutesEnum } from './my-zone-routes.enum';
import { MyZoneContainer } from './my-zone.container';

const routes: Routes = [
    {
        path: '',
        component: MyZoneContainer,
        data: {
            title: 'Mijn verzekeringsmap - InShared',
            description:
                'Het gemak van alles online. Regel uw verzekeringen makkelijk en snel via uw digitale Verzekeringsmap.',
        },
        canActivate: [AuthenticateGuard],
        children: [
            {
                path: '',
                redirectTo: MyZoneRoutesEnum.MyInsurances,
                pathMatch: 'full',
                data: {
                    /** TODO: WINS-5544 - meta description van mijn verzekeringen mag op 1 plek */
                    description:
                        'Het gemak van alles online. Regel uw verzekeringen makkelijk en snel via uw digitale Verzekeringsmap.',
                },
            },
            {
                path: MyZoneRoutesEnum.Insurances,
                redirectTo: MyZoneRoutesEnum.MyInsurances,
                pathMatch: 'full',
            },
            {
                path: MyZoneRoutesEnum.MyInsurances,
                loadChildren: () => import('./pages/insurances/insurances.module').then((m) => m.InsurancesModule),
                data: {
                    description:
                        'Het gemak van alles online. Bekijk uw verzekeringen makkelijk en snel via uw digitale Verzekeringsmap.',
                },
            },
            {
                path: `${MyZoneRoutesEnum.MyInsurances}-lib`,
                loadComponent: () =>
                    import('@my-zone/insurances/feature-insurances').then((m) => m.FeatureInsurancesComponent),
                data: {
                    description:
                        'Het gemak van alles online. Bekijk uw verzekeringen makkelijk en snel via uw digitale Verzekeringsmap.',
                },
            },
            {
                path: MyZoneRoutesEnum.MyClaims,
                loadChildren: () => import('./pages/claims/claims.module').then((m) => m.ClaimsModule),
                data: {
                    title: 'Mijn Verzekeringsmap - Mijn schades - InShared',
                    description:
                        'Het gemak van alles online. Volg makkelijk en snel gemelde schades in uw digitale Verzekeringsmap. Log in met uw e-mailadres en wachtwoord.',
                },
            },
            {
                path: `${MyZoneRoutesEnum.MyData}`,
                loadChildren: () =>
                    import('@my-zone/my-details/feature-my-details').then((m) => m.FeatureMyDetailsModule),
                data: {
                    title: 'Mijn verzekeringsmap - Mijn gegevens - InShared',
                    description:
                        'Het gemak van alles online. Pas uw gegevens makkelijk en snel aan in uw digitale Verzekeringsmap. Log in met uw e-mailadres en wachtwoord.',
                },
            },
            {
                path: MyZoneRoutesEnum.MyTerms,
                redirectTo: MyZoneRoutesEnum.Terms,
                pathMatch: 'full',
            },
            {
                path: MyZoneRoutesEnum.Terms,
                loadChildren: () =>
                    import('./pages/terms-and-conditions/terms-and-conditions.module').then(
                        (m) => m.TermsAndConditionsModule,
                    ),
                data: {
                    description: '',
                },
            },
            {
                path: `${MyZoneRoutesEnum.AnnualReward}`,
                loadComponent: () =>
                    import('@inshared/my-zone/netherlands/annual-reward/feature-annual-reward').then(
                        (c) => c.AnnualRewardComponent,
                    ),
                data: {
                    title: 'Mijn Verzekeringsmap - JaarBalans - InShared',
                },
            },
            {
                path: MyZoneRoutesEnum.MyInvoices,
                loadChildren: () =>
                    import('@inshared/my-zone/invoice/feature-invoice').then((m) => m.FeatureInvoiceModule),
            },
            {
                path: MyZoneRoutesEnum.SelfService,
                redirectTo: MyZoneRoutesEnum.MyInsurances,
                pathMatch: 'full',
            },
            {
                path: `${MyZoneRoutesEnum.SelfService}/${MyZoneRoutesEnum.Cancel}`,
                loadChildren: () => import('./pages/cancel/cancel.module').then((m) => m.CancelModule),
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class MyZoneRoutingModule {}
